import React, { useContext, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import GlobalContext from './context/GlobalContext'

import SuspenseWrapper from "./components/wrapper/Index"
import ScrollToTop from "./components/layout/scrollToTop/index";
const Navbar = React.lazy(() => import('./components/layout/navbar/navbar'))
const Footer = React.lazy(() => import('./components/layout/footer/footer'))

function App() {
    const { globalSettings } = useContext(GlobalContext)

    useEffect(() => {
        document.documentElement.classList.toggle('dark', globalSettings.isDarkMode);
    }, [globalSettings.isDarkMode])
    
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Navbar />

            <div className="container max-w-screen-xl mx-auto   flex-1" style={{ marginTop: '52px' }}>
            <Routes>
                <Route 
                    index 
                    element={<SuspenseWrapper path="pages/main/main" />}
                />


                <Route 
                    path="prepare-sentences-by-topic" 
                    element={<SuspenseWrapper path="pages/prepareSentences" />}
                />

                <Route 
                    path="dialog-by-topic" 
                    element={<SuspenseWrapper path="pages/dialog/dialog" />}
                />


                <Route 
                    path="exercises" 
                    element={<SuspenseWrapper path="pages/exercises/list/Index" />}
                />
                <Route 
                    path="exercises/:type" 
                    element={<SuspenseWrapper path="pages/exercises/exerciseTense/Index.js" />}
                />


                <Route 
                    path="flashcards" 
                    element={<SuspenseWrapper path="pages/flashcards/listOfSets" />}
                />
                <Route 
                    path="flashcards/:setId" 
                    element={<SuspenseWrapper path="pages/flashcards/listOfValues" />}
                />
                <Route 
                    path="flashcards/:setId/learn" 
                    element={<SuspenseWrapper path="pages/flashcards/learn" />}
                />


                <Route 
                    path="reader" 
                    element={<SuspenseWrapper path="pages/reader/listOfTexts/listOfTextsIndex" />}
                />
                <Route 
                    path="reader/:textId" 
                    element={<SuspenseWrapper path="pages/reader/itemText/itemTextIndex" />}
                />


                <Route 
                    path="learn" 
                    element={<SuspenseWrapper path="pages/learn/listOfLevels/Index" />}
                />
                <Route 
                    path="learn/create" 
                    element={<SuspenseWrapper path="pages/learn/postCreate/Index/Index" />}
                />
                <Route 
                    path="learn/grammar/:sectionId" 
                    element={<SuspenseWrapper path="pages/learn/grammar/listOfPosts/Index" />}
                />
                <Route 
                    path="learn/grammar/:sectionId/:postId" 
                    element={<SuspenseWrapper path="pages/learn/grammar/postData/Index" />}
                />
                <Route 
                    path="learn/vocabulary/:sectionId" 
                    element={<SuspenseWrapper path="pages/learn/vocabulary/listOfPosts/Index" />}
                />
                <Route 
                    path="learn/vocabulary/:sectionId/:postId" 
                    element={<SuspenseWrapper path="pages/learn/vocabulary/postData/Index" />}
                />


                <Route 
                    path="*" 
                    element={<SuspenseWrapper path="pages/404/Index" />}
                />
            </Routes>
            </div>

            <Footer />
        </BrowserRouter>
    )
}

export default App